import { Building2, TrendingUp, ShieldCheck, Handshake } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const VALUES = [
  {
    icon: Building2,
    title: "Built for Your Business",
    text: "Solutions designed around real operational needs — not generic templates.",
  },
  {
    icon: TrendingUp,
    title: "Designed to Scale",
    text: "Architecture that can grow with the company, from first release to full platform.",
  },
  {
    icon: ShieldCheck,
    title: "Security from the Start",
    text: "Security and responsible development practices incorporated throughout development.",
  },
  {
    icon: Handshake,
    title: "Long-Term Technology Partnership",
    text: "Software should keep improving after launch. We build for the long run.",
  },
];

export default function WhyUs() {
  return (
    <section className="bg-[#F8FAFC] py-28 sm:py-36" data-testid="why-logitech-nexus">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow light>Why LogiTech Nexus</Eyebrow>
          <h2 className="mt-4 max-w-2xl font-display text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            A technology partner built around outcomes, not hours.
          </h2>
        </Reveal>
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.08} y={20}>
              <div
                className="group h-full rounded-2xl border border-slate-200 bg-white p-7 shadow-[0_1px_2px_rgba(15,23,42,0.04)] transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-blue-300 hover:shadow-[0_16px_40px_rgba(59,130,246,0.12)]"
                data-testid={`value-card-${i}`}
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-blue-600 transition-colors duration-300 group-hover:bg-blue-600 group-hover:text-white">
                  <v.icon size={20} />
                </span>
                <h3 className="mt-6 font-display text-lg font-semibold text-slate-900">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{v.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
